/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockGoodsListBarcodeItem } from './StockGoodsListBarcodeItem';
import {
    StockGoodsListBarcodeItemFromJSON,
    StockGoodsListBarcodeItemFromJSONTyped,
    StockGoodsListBarcodeItemToJSON,
    StockGoodsListBarcodeItemToJSONTyped,
} from './StockGoodsListBarcodeItem';
import type { StockGoodsListSkuProductItem } from './StockGoodsListSkuProductItem';
import {
    StockGoodsListSkuProductItemFromJSON,
    StockGoodsListSkuProductItemFromJSONTyped,
    StockGoodsListSkuProductItemToJSON,
    StockGoodsListSkuProductItemToJSONTyped,
} from './StockGoodsListSkuProductItem';

/**
 * 
 * @export
 * @interface StockGoodsListSkuItem
 */
export interface StockGoodsListSkuItem {
    /**
     * SKU主键ID
     * @type {number}
     * @memberof StockGoodsListSkuItem
     */
    skuId?: number;
    /**
     * SKU编码，页面显示用
     * @type {string}
     * @memberof StockGoodsListSkuItem
     */
    skuCode?: string;
    /**
     * SKU图片URL
     * @type {string}
     * @memberof StockGoodsListSkuItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {Array<StockGoodsListBarcodeItem>}
     * @memberof StockGoodsListSkuItem
     */
    barcodes?: Array<StockGoodsListBarcodeItem>;
    /**
     * 可用库存数量
     * @type {number}
     * @memberof StockGoodsListSkuItem
     */
    availableQuantity?: number;
    /**
     * SKU注册单价(¥)，取自 sku.unit_price
     * @type {number}
     * @memberof StockGoodsListSkuItem
     */
    skuCost?: number;
    /**
     * 
     * @type {Array<StockGoodsListSkuProductItem>}
     * @memberof StockGoodsListSkuItem
     */
    skuProducts?: Array<StockGoodsListSkuProductItem>;
    /**
     * 当前 SKU 是否存在可原包装出库的库存批次（任一关联 goods.origin_package_outbound=1）
     * @type {boolean}
     * @memberof StockGoodsListSkuItem
     */
    hasOriginalPackagingBatch?: boolean;
}

/**
 * Check if a given object implements the StockGoodsListSkuItem interface.
 */
export function instanceOfStockGoodsListSkuItem(value: object): value is StockGoodsListSkuItem {
    return true;
}

export function StockGoodsListSkuItemFromJSON(json: any): StockGoodsListSkuItem {
    return StockGoodsListSkuItemFromJSONTyped(json, false);
}

export function StockGoodsListSkuItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockGoodsListSkuItem {
    if (json == null) {
        return json;
    }
    return {
        
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'barcodes': json['barcodes'] == null ? undefined : ((json['barcodes'] as Array<any>).map(StockGoodsListBarcodeItemFromJSON)),
        'availableQuantity': json['availableQuantity'] == null ? undefined : json['availableQuantity'],
        'skuCost': json['skuCost'] == null ? undefined : json['skuCost'],
        'skuProducts': json['skuProducts'] == null ? undefined : ((json['skuProducts'] as Array<any>).map(StockGoodsListSkuProductItemFromJSON)),
        'hasOriginalPackagingBatch': json['hasOriginalPackagingBatch'] == null ? undefined : json['hasOriginalPackagingBatch'],
    };
}

export function StockGoodsListSkuItemToJSON(json: any): StockGoodsListSkuItem {
    return StockGoodsListSkuItemToJSONTyped(json, false);
}

export function StockGoodsListSkuItemToJSONTyped(value?: StockGoodsListSkuItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'imageUrl': value['imageUrl'],
        'barcodes': value['barcodes'] == null ? undefined : ((value['barcodes'] as Array<any>).map(StockGoodsListBarcodeItemToJSON)),
        'availableQuantity': value['availableQuantity'],
        'skuCost': value['skuCost'],
        'skuProducts': value['skuProducts'] == null ? undefined : ((value['skuProducts'] as Array<any>).map(StockGoodsListSkuProductItemToJSON)),
        'hasOriginalPackagingBatch': value['hasOriginalPackagingBatch'],
    };
}

